import type { IconProps } from './types';

function StackIcon(props: IconProps) {
  const { size = 32, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M6.00024 15.4453L15.9987 21L25.9971 15.4453" stroke={color} strokeWidth="2.13334" />
      <path d="M6.00024 20.4446L15.9987 25.9993L25.9971 20.4446" stroke={color} strokeWidth="2.13334" />
      <path
        d="M15.9999 5.99927L6.99988 10.9993L15.9999 15.9993L24.9999 10.9993L15.9999 5.99927Z"
        stroke={color}
        strokeWidth="2.13334"
      />
    </svg>
  );
}

export { StackIcon };
